import React, {useState} from 'react'
import styled from 'styled-components'
import Jumbotron from 'react-bootstrap/Jumbotron'
import {Grid, TextField, Box, makeStyles, Button} from '@material-ui/core'
import SaveIcon from '@material-ui/icons/Save'
import {useHistory} from 'react-router-dom'
import {setGlobal} from 'reactn'
import {useTranslation} from 'react-i18next'
import {updateUserPassword} from '../common/actions/User'

const PasswordResetDiv = styled.div`
  width: 100%;
  height: 100%;
  vertical-align: center;
`

const useStyles = makeStyles(theme => ({
  infoBackground: {
    borderRadius: 3,
    border: 1,
    borderStyle: 'solid',
    borderColor: '#ef5350',
    background: '#ffcdd2',
    marginTop: 30,
    marginBottom: 40,
  },
}))

export default function PasswordReset(props) {
  const classes = useStyles()
  const history = useHistory()
  const [password, setPassword] = useState({
    newPassword: '',
    confirmPassword: '',
    currentPassword: '',
  })
  const {t} = useTranslation()

  const handleChange = textField => event => {
    setPassword({
      ...password,
      [textField]: event.target.value,
    })
  }

  function savePasswordClick(event) {
    let message = ''
    let variant = t('flash-message.error-variant')
    const validator = /^(?=.*\d)(?=.*[a-z])[0-9a-zA-Z]{8,20}$/
    if (password.newPassword !== password.confirmPassword) {
      message = t('password-reset.confirm-password-mismatch')
    } else if (
      password.newPassword === '' ||
      password.confirmPassword === '' ||
      password.currentPassword === ''
    ) {
      message = t('password-reset.blank-fields')
    } else if (!validator.test(password.newPassword)) {
      message = t('password-reset.regex-validation')
    }
    if (message) {
      setGlobal({
        openFlashMessage: true,
        flashMessageText: message,
        flashMessageVariant: variant,
      })
      return
    } else {
      api_response_success()
    }
  }

  function api_response_success() {
    updateUserPassword(password.currentPassword, password.newPassword)
      .then(response => {
        let message = ''
        let variant = t('flash-message.error-variant')
        if (response.mismatch) {
          message = t('password-reset.current-password-mismatch')
        } else if (response.errors) {
          message = 'Password ' + response.errors
        } else {
          message = t('password-reset.save-successful')
          variant = t('flash-message.success-variant')
          localStorage.setItem('temp_password', false)
        }
        setGlobal({
          openFlashMessage: true,
          flashMessageText: message,
          flashMessageVariant: variant,
        })
        if (variant === t('flash-message.error-variant')) {
          return
        } else {
          return history.push({pathname: '/'})
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

  return (
    <PasswordResetDiv>
      <Jumbotron>
        <Grid container item xs={12} justify="flex-end">
          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<SaveIcon />}
            style={{textTransform: 'none'}}
            margin={3}
            onClick={savePasswordClick}
          >
            {t('password-reset.save')}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Box height={40} className={classes.infoBackground}>
            <Box margin={1} fontSize={16} fontWeight="bold">
              {t('password-reset.change-password-title')}
            </Box>
          </Box>
        </Grid>

        <Grid container item xs={12} spacing={5}>
          <Grid container item xs={4} justify="flex-end" alignItems="center">
            <Box margin={1} fontSize={16}>
              <p>{t('password-reset.current-password')}</p>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <TextField
              size="small"
              id="current-password"
              label={t('password-reset.current-password')}
              value={password.currentPassword}
              type="password"
              fullWidth
              variant="outlined"
              onChange={handleChange('currentPassword')}
            />
          </Grid>
        </Grid>

        <Grid container item xs={12} spacing={5}>
          <Grid container item xs={4} justify="flex-end" alignItems="center">
            <Box margin={1} fontSize={16}>
              <p>{t('password-reset.password')}</p>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <TextField
              size="small"
              id="new-password"
              label={t('password-reset.password')}
              value={password.newPassword}
              type="password"
              fullWidth
              variant="outlined"
              onChange={handleChange('newPassword')}
            />
          </Grid>
        </Grid>
        <Grid container item xs={12} spacing={5}>
          <Grid container item xs={4} justify="flex-end" alignItems="center">
            <Box margin={1} fontSize={16}>
              <p>{t('password-reset.password-confirmation')}</p>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <TextField
              size="small"
              id="confirm-password"
              label={t('password-reset.confirm-new-password')}
              value={password.confirmPassword}
              type="password"
              fullWidth
              variant="outlined"
              onChange={handleChange('confirmPassword')}
            />
          </Grid>
        </Grid>
      </Jumbotron>
      {/* <PandaLogo src={panda} alt="panda head"></PandaLogo> */}
    </PasswordResetDiv>
  )
}
